import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { pollDuplicateProjectJobs } from '../../redux/projectDataSlice';
import { isActiveDuplicateJob } from '../../utils/duplicateProjectJobs';

const DuplicateProjectJobPoller = () => {
    const dispatch = useDispatch();
    const duplicateJobs = useSelector(state => state.projectData.duplicateJobs ?? []);
    const userId = useSelector(state => state.user?.user?.id);
    const activeCount = duplicateJobs.filter(isActiveDuplicateJob).length;

    React.useEffect(() => {
        if (!userId || activeCount === 0) return undefined;

        const poll = () => {
            dispatch(pollDuplicateProjectJobs());
        };

        poll();
        const intervalId = window.setInterval(poll, 5000);
        return () => window.clearInterval(intervalId);
    }, [dispatch, userId, activeCount]);

    return null;
};

export default DuplicateProjectJobPoller;
